<template>
  <div class="p-3 text-left">
    <h2>{{ $t('general.user_requests') }}</h2>
    <hr />
    <transition name="page" appear>
      <el-card>
        <table class="el-table el-table--striped el-tab">
          <thead>
            <tr>
              <th>{{ $t('general.status') }}</th>
              <th>{{ $t('general.firstname') }}</th>
              <th>{{ $t('general.lastname') }}</th>
              <th>{{ $t('general.company') }}</th>
              <th>{{ $t('general.email') }}</th>
              <th>{{ $t('general.phone') }}</th>
              <th>{{ $t('general.street') }}</th>
              <th>{{ $t('general.actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="request in requests" :key="request.id">
              <td>
                <StatusTag :status="request.get('status')" />
              </td>
              <td>{{ request.get('firstname') }}</td>
              <td>{{ request.get('lastname') }}</td>
              <td>{{ request.get('company') }}</td>
              <td>{{ request.get('email') }}</td>
              <td>{{ request.get('phone') }}</td>
              <td>
                {{
                  `${request.get('country') || ''}-${request.get('zipCode') || ''} ${request.get('city') ||
                    ''}, ${request.get('street') || ''} ${request.get('streetAdditional') || ''}`
                }}
              </td>
              <td>
                <el-button type="success" circle @click="acceptRequest(request)">
                  <i class="el-icon-check" />
                </el-button>
                <el-button type="danger" circle @click="declineRequest(request)">
                  <i class="el-icon-delete" />
                </el-button>
              </td>
            </tr>
          </tbody>
        </table>
      </el-card>
    </transition>
  </div>
</template>

<script>
import StatusTag from '../../../components/atoms/StatusTag';
export default {
  name: 'AdminUserRequestsView',
  components: { StatusTag },
  props: {},
  async mounted() {
    await this.onLoad();
  },
  destroyed() {},
  data() {
    return {
      requests: [],
    };
  },
  computed: {},
  methods: {
    async onLoad() {
      let query = new this.$parse.Query('Request');
      query.limit(3000);
      query.addDescending('createdAt');
      query.addDescending('status');
      this.requests = await query.find();
    },
    acceptRequest(request) {
      let data = request.toJSON();
      data.generatePassword = true;
      data.roleName = 'User';

      this.$parse.Cloud.run('registerUser', data, {})
        .then(async (response) => {
          await request.destroy();
          this.$message.success(response.msg);
          await this.onLoad();
        })
        .catch((error) => {
          this.$message.error(JSON.stringify(error));
        });
    },
    async declineRequest(request) {
      request.set('status', 'rejected');
      await request.save();
      this.$message.success(this.$t('general.last_request_deleted'));
      await this.onLoad();
    },
  },
};
</script>

<style scoped></style>
